module.exports = __webpack_public_path__ + "assets/subscriptions.49affb0c.svg";